import {ISimplePresentation, ISimplePresentationRunnerController} from "../SimplePresentationRunner";
import {Game} from "../Game";
import {IMonster, MONSTER_EXPRESSION, SCATTER_METER_MAP} from "../server/IData";
import {gsap} from "gsap";
import {MonsterSymbol} from "../reels/MonsterSymbol";
import { Sound } from "../sound/Sound";

export class FeatureIntroRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return Game.isFreespinTriggered() && !Game.model.data.brokeTheBank;
    }

    public start(controller: ISimplePresentationRunnerController): void {
        controller.setSkipCallback();

        const scatterCount: number = Game.model.gameData?.scatterCount || 0,
            monsters: IMonster[] = Game.model.gameData.monsters;

        let tl: gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            Game.scatterInventory.stopInventoryAnimations(true);
        })

        let isPlayBeerDrink: boolean = true;

        for (let ctr: number = 0; ctr < monsters.length; ctr++) {
            const monster: IMonster = monsters[ctr];
            if (!monster.path || monster.path.length === 0) {
                continue;
            }

            const monsterSymbol: MonsterSymbol = Game.reelsView.reelModels[monster.path[0].x].getMonsterSymbolAt(monster.symbol);
            const monsterHasScatter: boolean = monster.collectedScatterCount > 0;

            monsterSymbol.setMonsterWalkIdx(ctr);

            if (monsterHasScatter) {
                tl.add(monsterSymbol.sipBeer(monster.collectedScatterCount), 0);

                if (isPlayBeerDrink){
                    tl.add(()=>{
                        Game.soundPlayer.playSound(Sound.BEER_DRINK, 1);
                    }, 0)
                    isPlayBeerDrink = false;
                }
            } else {
                tl.add(monsterSymbol.getStateAnimation(MONSTER_EXPRESSION.ANGRY, 5), 0);
            }
        }

        if (scatterCount === 3) {
            tl.add(Game.scatterInventory.getStateAnimation(SCATTER_METER_MAP["FS"]), "<");
            tl.add(Game.featureIntro.showFSIntro(() => controller.finish()));
        } else if (scatterCount === 4) {
            tl.add(Game.scatterInventory.getStateAnimation(SCATTER_METER_MAP["SFS"]), "<");
            tl.add(Game.featureIntro.showSFSIntro(() => controller.finish()));
        }
    }
}